import('select2/dist/js/select2.js');
import('select2/dist/css/select2.min.css');

import('select2/dist/js/i18n/en.js');
import('select2/dist/js/i18n/de.js');
import('select2/dist/js/i18n/da.js');
import('select2/dist/js/i18n/es.js');
import('select2/dist/js/i18n/sv.js');
import('select2/dist/js/i18n/tr.js');
import('select2/dist/js/i18n/ro.js');
import('select2/dist/js/i18n/fr.js');
import('select2/dist/js/i18n/it.js');
import('select2/dist/js/i18n/ru.js');

import('select2-bootstrap-theme/dist/select2-bootstrap.min.css');
import('@appPath/css/select2-bootstrap-override.css');

